import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postActivityProf } from "./ServiceActivityProf";
import { useTranslation } from "react-i18next";

export default function AddActivityProf() {
 const { t } = useTranslation();
  const navigate = useNavigate();

  const [data, setData] = useState({
    natureActivityType: "",
    activityProf: "",
    activityProfArab: "",
    activityProfAng: "",
  });

  const [errorMessage, setErrorMessage] = useState({});
  // Gestion des champs
const onInputchange = (e) => {

    const { name, value } = e.target;

    setData({
        ...data,
        [name]: value,
    });

    setErrorMessage((prev) => ({
        ...prev,
        [name]: ""
    }));
};

const validateForm = () => {
    const errors = {};
    // Validation du type d'activité
    if (
        !data.natureActivityType ||
        data.natureActivityType.trim() === ""
    ) {
        errors.natureActivityType =
            t("validation.activityTypeRequired");
    }

    // Activité français obligatoire
    if (
        !data.activityProf ||
        data.activityProf.trim() === ""
    ) {

        errors.activityProf =
            t("validation.activityProfRequired");

    }
    setErrorMessage(errors);
    return Object.keys(errors).length === 0;
};



  // Enregistrement
const onSubmit = async (e) => {

    e.preventDefault();

    // Validation locale
    if (!validateForm()) {

        toast.error(
            t("validation.correctErrors"),
            {
                position: "bottom-right",
                autoClose: 3000,
            }
        );

        return;
    }

    try {

        await postActivityProf(data);

        toast.success(
            t("activiteProf.saveSuccess"),
            {
                position: "bottom-right",
                autoClose: 2000,
            }
        );

        setData({
            natureActivityType: "",
            activityProf: "",
            activityProfArab: "",
            activityProfAng: "",
        });

        setErrorMessage({});

        navigate("/Listactivityprof");

    } catch (error) {

        if (
            error.response &&
            error.response.data &&
            error.response.data.errors
        ) {

            const errorArray =
                error.response.data.errors;

            const errorObject = {};

            errorArray.forEach((err) => {

                if (err.indexOf(":") > -1) {

                    const [field, message] =
                        err.split(":");

                    errorObject[field.trim()] =
                        message.trim();
                }

            });

            setErrorMessage(errorObject);

        } else {

            toast.error(
                t("common.error")
            );

            console.error(error);
        }
    }
};

return (
    <div
      className="div-width"
      style={{ marginTop: "6rem" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">

          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>

            <Link
              className="mx-2"
              to="/"
            >
              {t("menu.home")}
            </Link>
          </li>

          <li className="breadcrumb-item">
            <Link
              className="mx-2"
              to="/Listactivityprof"
            >
               {t("activiteProf.titre")}
            </Link>
          </li>

          <li className="breadcrumb-item active">
            {t("activiteProf.new")}
          </li>

        </ol>
      </nav>

      <div className="table-container">

        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-folder-plus fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">

          <h4 className="ajst-titre mb-4">
           {t("activiteProf.new")}
          </h4>

          <form onSubmit={onSubmit}>

            <div className="row justify-content-center">

              <div className="col-md-6">


                        {/* natureActivityType*/}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("monProfile.activityType")}
                  </label>

<select
    className={
        errorMessage.natureActivityType
            ? "form-select is-invalid"
            : "form-select"
    }
    name="natureActivityType"
    value={data.natureActivityType}
    onChange={onInputchange}
>
                    <option value="">-- {t("common.select")} --</option>
                    <option value="C">{t("monProfile.consultantAgriculture")}</option>
                    <option value="L">{t("monProfile.livestockAdvisor")}</option>
                    <option value="S">{t("monProfile.supplier")} </option>
                  </select>

                  {errorMessage.natureActivityType && (
                    <div className="text-danger mt-1">
                      {errorMessage.natureActivityType}
                    </div>
                  )}

                </div>


                {/* Activité FR */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.french")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="activityProf"
                    value={data.activityProf}
                    onChange={onInputchange}
                  />

                  {errorMessage.activityProf && (
                    <div className="text-danger mt-1">
                      {errorMessage.activityProf}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.arabic")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                   {t("common.arabic")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="activityProfArab"
                    value={data.activityProfArab}
                    onChange={onInputchange}
                    dir="rtl"
                  />

                  {errorMessage.activityProfArab && (
                    <div className="text-danger mt-1">
                      {errorMessage.activityProfArab}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.english")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.english")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="activityProfAng"
                    value={data.activityProfAng}
                    onChange={onInputchange}
                  />

                  {errorMessage.activityProfAng && (
                    <div className="text-danger mt-1">
                      {errorMessage.activityProfAng}
                    </div>
                  )}

                </div>

              </div>

            </div>

            <div className="text-center mt-4">

              <button
                type="submit"
                className="btn btn-outline-primary"
              >
                {t("button.save")}
              </button>

              <Link
                to="/Listactivityprof"
                className="btn btn-outline-success mx-2"
              >
                {t("button.close")}
              </Link>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}